<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section epub:type="dedication" role="doc-dedication">
<p class="Dedication-ded" id="ded"><span aria-label="v" id="pg_v" role="doc-pagebreak"><i>For Rebecca,<br/>Who can summon the storm,<br/>but prefers to command the sun.</i></span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?675dd3f0